import React, { useEffect, useRef } from "react";

const ScrollProgress = () => {
  const ref = useRef(null);

  useEffect(() => {
    const update = () => {
      const node = ref.current;
      if (!node) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      node.style.width = `${Math.max(0, Math.min(100, pct))}%`;
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return <div className="mk-scroll-progress" ref={ref} aria-hidden="true" />;
};

export default ScrollProgress;
